// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {Href} from 'docs/markdoc/attribute-types';

export const Button: MarkdocTagRegistration = {
  tag: 'button',
  component: 'DocsButton',
  children: ['strong', 'em', 'code', 'text', 'tag'],
  attributes: {
    type: {
      type: String,
      default: 'button',
      description:
        'Controls whether the button is styled as a link or a button. Can be: "link" or "button"',
    },
    href: {
      type: Href,
      description: 'The link which opens when this is a link.',
    },
    analytics: {
      type: Object,
      description:
        'An object like {source: "source_name", action: "action_name"}. The action is the unique identifier specifying what event occured and is used to search for your event. The source is where the event occurs.',
    },
    icon: {
      type: String,
      description: 'The Sail icon name for the icon next to the button text.',
    },
    iconPosition: {
      type: String,
      description:
        'The Sail icon position, can be either "left" or "right". Default is to the right',
    },
  },
};
